// src/store/slices/studentSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface callState {
    selectedView: string;
}

const initialState: callState = {
    selectedView: '/info',
};

const callSlice = createSlice({
    name: 'call',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = callSlice.actions;
export default callSlice.reducer;